import { useMemo } from "react";

import { useAppNudgeStore } from "@faire/retailer/features/Nudges/useAppNudgeStore";
import { useFaireDirectMarketplaceIncentive } from "@faire/retailer/hooks/promos/useFaireDirectMarketplaceIncentive";
import { useMilestone } from "@faire/retailer/stores/domain/useMilestone";

interface IMarketplaceIncentiveNudge {
  shouldShowMarketplaceIncentiveNudge: boolean;
  hasAcknowledgedMarketplaceIncentiveNudge: boolean;
  setAppNudgeStore: ReturnType<typeof useAppNudgeStore>[1];
  onDismiss: () => void;
}

export const useMarketplaceIncentiveNudge: () => IMarketplaceIncentiveNudge =
  () => {
    const [{ hasAcknowledgedMarketplaceIncentiveNudge }, setAppNudgeStore] =
      useAppNudgeStore(["hasAcknowledgedMarketplaceIncentiveNudge"]);
    const {
      hasIncentive,
      lessThanOneDayRemaining,
      isFaireDirectMarketplaceIncentive,
    } = useFaireDirectMarketplaceIncentive();

    const { setHasOccurred, hasOccurred } = useMilestone(
      "FD_MARKETPLACE_DISCOUNT_NUDGE_MODAL_DISMISSED"
    );

    const shouldShowMarketplaceIncentiveNudge = useMemo(
      () =>
        hasIncentive &&
        lessThanOneDayRemaining &&
        isFaireDirectMarketplaceIncentive &&
        !hasAcknowledgedMarketplaceIncentiveNudge &&
        !hasOccurred,
      [
        hasIncentive,
        hasAcknowledgedMarketplaceIncentiveNudge,
        hasOccurred,
        isFaireDirectMarketplaceIncentive,
        lessThanOneDayRemaining,
      ]
    );
    return {
      shouldShowMarketplaceIncentiveNudge,
      hasAcknowledgedMarketplaceIncentiveNudge,
      setAppNudgeStore,
      onDismiss: setHasOccurred,
    };
  };
